import prettier from '../../assets/prettier.png';

import '../../styles/days.scss';

const Five = () => (
  <div className='days full-image'>
    <img src={prettier} alt='prettier' />
  </div>
);

export default Five;
